import { render, staticRenderFns } from "./PreviewEmail.vue?vue&type=template&id=4fd21a5a&"
import script from "./PreviewEmail.vue?vue&type=script&lang=js&"
export * from "./PreviewEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports